export const isBFPOPostcode = (postCode) => {
  const SUB_STRING_END_INDEX = 3;
  const BFPO_PREFIX = 'BF1';
  return postCode.substring(0, SUB_STRING_END_INDEX).toLowerCase() === BFPO_PREFIX.toLowerCase();
};
